<template>
  <Field
    :name="name"
    type="checkbox"
    :rules="rules ?? ''"
    :value="true"
    :unchecked-value="false"
    @keyup.space="selectBoxOnClick"
    @keyup.enter="selectBoxOnClick"
    v-slot="{ field, errorMessage }"
  >
    <label
      class="checkbox"
      :for="checkboxID"
    >
      <span class="checkbox__wrapper">
        <input
          :id="checkboxID"
          class="checkbox__input"
          :class="{'checkbox__input--error': !!errorMessage}"
          type="checkbox"
          :name="name"
          v-bind="field"
          :value="true"
          :disabled="disabled"
          :aria-invalid="!!errorMessage"
          :aria-errormessage="!!errorMessage ? `${checkboxID}-error` : null"
        >
        <span class="checkbox__box"
              role="checkbox"
              :aria-label="$t('global.checkbox.aria.label', [name])"
              tabindex="0"
              @keydown="handleKeyDown"
        />
        <span
          class="checkbox__label"
          :class="{
            'checkbox__label--disabled': disabled,
            'input__label--required': isRequired
          }"
          v-html="label"
        />
      </span>
    </label>
  </Field>

  <ErrorMessage
    v-if="!suppressErrorMessages"
    as="span"
    class="input__error | input-error"
    :name="name"
    :id="`${checkboxID}-error`"
  />
</template>

<script>
import randomId from '../../utilities/js/randomId/randomId';
import {ErrorMessage, Field} from "vee-validate";

export default {
    components: { ErrorMessage, Field },
    model: {
      prop: 'checked',
      event: 'change'
    },
    props: {
      checked: Boolean,
      name: {
        type: String,
        default() {
          return '';
        }
      },
      label: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      rules: {
        type: String,
        default: null
      },
      suppressErrorMessages: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        checkboxID: this.id ? this.id : randomId(this.checked)
      }
    },
    computed: {
      isRequired() {
        return this.rules?.includes('required');
      },
    },
    methods: {
      selectBoxOnClick() {
        this.$refs.inputRef.click();
      },
      handleKeyDown(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          event.target.click();
        }
      }
    },
  };

</script>
